const Icon = ({ className = '', name, style = {} }) => {
	return (
		<svg style={style} className={className}>
			<use xlinkHref={'#' + name} />
		</svg>
	);
};

export default Icon;
